import { MappingPage } from "./MappingPage";
import { IBaseGrid } from "Grids/Interfaces";
import { Mapping, QueryParameter } from "Core";
import { BaseGrid } from "Grids";
import { AppContext } from "Core/AppContext";
import { GridTypes, MappingDisplayTypes } from "Service/Client";

export class ParentChildMappingPage extends MappingPage {
    private container: JQuery;
    // private parentContainer: JQuery;
    private childContainer: JQuery;
    private childHeader: JQuery;

    private splitter: kendo.ui.Splitter;

    private childGrids: BaseGrid[] = [];

    private childMapping: Mapping;

    /**
     * @hidden
     */
    public isParentChild: boolean = true;

    /**
     * Initialize the {@link ParentChild}.
     * @param pageToken The pageToken created on the server.
     * @param textBlockCategory TextBlockCategory to use for textblocks.
     * @hidden
     */
    public async initialize(textBlockCategory: string): Promise<void> {
        await super.initialize(textBlockCategory);

        this.container = $(".dms-content-wrapper");
        this.container.append(`<div class="dms-parent"><div class="dms-content-container"></div></div>`);
        this.container.append(`<div class="dms-child"></div>`);
        this.childContainer = this.container.find(".dms-child");

        this.splitter = new kendo.ui.Splitter(this.container[0], {
            panes: [
                {
                    collapsible: true,
                    size: QueryParameter.get("leftpanewidth"),
                    scrollable: false,
                },
                {},
            ],
        });
    }

    /**
     * Resize ParentChild
     * @hidden
     */
    public resize(): void {
        let height = this.getAvailableHeight();
        if (this.container) {
            this.container.height(height - 1);
        }
        if (this.mapping) {
            this.mapping.setHeight(height - 2);
        }
        if (this.iframe) {
            this.iframe.height(height - 5);
        } else {
            let childHeaderHeight = 0;
            if (this.childHeader) {
                childHeaderHeight = this.childHeader.outerHeight(true);
            }

            if (this.childMapping) {
                this.childMapping.setHeight(height - childHeaderHeight - 2);
            }
        }
        if (this.splitter) {
            this.splitter.resize();
        }
    }

    /**
     * Clear the content of the child container.
     * @hidden
     */
    public clearChild(): void {
        // dispose all child grids.
        for (let i = 0, len = this.childGrids.length; i < len; i++) {
            let grid = this.childGrids[i];
            grid.dispose();
        }

        if (this.childMapping) {
            this.childMapping.dispose();
        }

        if (this.iframe) {
            this.iframe = null;
        }
        this.childGrids = [];
        this.childContainer.empty();
        QueryParameter.initialize(); // reset query parameters to querystring only.
    }

    /**
     * Reload all grids in the child container.
     * @hidden
     */
    public reloadChild(): void {
        // reload all child grids.
        for (let i = 0, len = this.childGrids.length; i < len; i++) {
            let grid = this.childGrids[i];
            if (grid.getGridType() != GridTypes.Filter) {
                grid.reload();
            }
        }
    }

    /**
     * Reload all grids in the child container.
     * @since 4.0.0
     */
    public reloadParent(): void {
        if (this.mapping) {
            this.mapping.reload();
        }
    }

    /**
     * Get all grids of this context (parent and child-grids).
     * @hidden
     */
    public getGrids(): Array<IBaseGrid> {
        let grids = super.getGrids();
        if (this.childMapping) {
            let childGrids = this.childMapping.getGrids();
            if (childGrids && childGrids.length > 0) {
                grids = grids.concat(childGrids);
            }
        }
        return grids;
    }

    public async loadChildParams(mappingName: string, params: string): Promise<void> {
        this.clearChild();
        // reset query parameters
        QueryParameter.initialize();
        QueryParameter.addFromQueryString(params, false);
        return this.loadChild(mappingName);
    }

    public async loadChildJson(mappingName: string, params: string): Promise<void> {
        this.clearChild();
        // reset query parameters
        QueryParameter.clear();
        let object = JSON.parse(params);
        QueryParameter.addFromObject(object);
        return this.loadChild(mappingName);
    }

    /**
     * Load a mapping into the child container.
     * @param mappingName Name of the mapping to load.
     * @hidden
     */
    public async loadChild(mappingName: string): Promise<void> {
        let useChildTextBlocks = QueryParameter.get("tbm") != "";
        let textBlockCategory = QueryParameter.get("tbm") || mappingName;
        let textblocks = await this.serviceProvider.TextBlock.load(AppContext.current.environment.LanguageCode, textBlockCategory);
        let pageTitle: string;
        if (useChildTextBlocks) {
            // this.currentTextBlockCategory = textBlockCategory;
            // let tbs = this.pageViewModel.get("TextBlock");
            // this.pageViewModel.set("TextBlock", $.extend(tbs, textblocks));
            pageTitle = this.serviceProvider.TextBlock.get("pageTitle", textBlockCategory);
        } else {
            this.currentTextBlockCategory = this.mapping.getMappingName(); // reset the category to the original mapping name (=parent mapping)
            pageTitle = this.serviceProvider.TextBlock.getChecked(textblocks[mappingName], "pageTitle", mappingName);
        }

        this.childHeader = $(`<div class='dms-parent-child-header'><h2>${pageTitle}</h2></div>`);
        this.childContainer.append(this.childHeader);

        this.childMapping = new Mapping(
            mappingName,
            textBlockCategory,
            this.serviceProvider,
            Promise.resolve(),
            AppContext.current.environment,
        );
        await this.childMapping.initialize(this.childContainer, MappingDisplayTypes.FilterAndGrids, null);
        this.resize();
    }

    private iframe: JQuery;

    public loadChildFromUrl(url: string): void {
        this.clearChild();

        this.iframe = $(
            `<iframe frameborder="0" style="overflow:hidden;overflow-x:hidden;overflow-y:scroll;border:0;width:100%;top:0px;left:0px;right:0px;bottom:0px" />`,
        );
        this.childContainer.append(this.iframe);
        this.iframe.attr("src", url);
        this.resize();
    }

    dispose(): void {
        super.dispose();

        if (this.childMapping) {
            this.childMapping.dispose();
        }

        if (this.splitter) {
            this.splitter.destroy();
        }
        if (this.container) {
            this.container.empty();
        }
    }
}
